import React, { useState, useEffect } from 'react';
import { ChevronDownIcon } from './Icons';

const SearchableSelect = ({ options, value, onChange, placeholder = "Select...", zIndex = 50 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  
  useEffect(() => {
    const match = options.find(o => o.id === value);
    if (match) {
      setSearchTerm(match.label);
    } else {
      setSearchTerm(value || '');
    }
  }, [value, options]);
  
  const filtered = options.filter(o => 
    o.id.toLowerCase().includes(searchTerm.toLowerCase()) || 
    o.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const handleSelect = (id, label) => {
    onChange(id);
    setSearchTerm(label);
    setIsOpen(false);
  };
  
  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsOpen(true);
    if (e.target.value === '') onChange('');
  };
  
  const handleFocus = (e) => {
    setIsOpen(true);
    e.target.select();
  };
  
  return (
    <div className="relative w-full">
      {isOpen && (
        <div 
          className="fixed inset-0 bg-transparent" 
          style={{ zIndex: zIndex - 1 }} 
          onClick={() => setIsOpen(false)}
        />
      )}
      <div className="relative" style={{ zIndex: isOpen ? zIndex : 1 }}>
        <input 
          className="w-full p-2 border border-gray-600 rounded shadow-sm text-sm font-medium focus:ring-yellow-500 focus:border-yellow-500 bg-gray-700 text-white placeholder-gray-400 pr-8" 
          value={searchTerm} 
          onChange={handleInputChange} 
          onFocus={handleFocus} 
          placeholder={placeholder} 
        />
        <div className="absolute right-2 top-2.5 pointer-events-none text-gray-400">
          <ChevronDownIcon />
        </div>
        {isOpen && (
          <div 
            className="absolute w-full bg-gray-800 border border-gray-600 rounded shadow-lg max-h-48 overflow-y-auto mt-1" 
            style={{ zIndex: zIndex + 1 }}
          >
            {filtered.length > 0 ? (
              filtered.map(opt => (
                <div 
                  key={opt.id} 
                  className="px-3 py-2 text-xs hover:bg-yellow-500/20 cursor-pointer text-gray-200" 
                  onClick={() => handleSelect(opt.id, opt.label)}
                >
                  <span className="font-bold">{opt.label}</span>
                  {opt.id !== opt.label && <span className="text-gray-500 ml-1">({opt.id})</span>}
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-xs text-gray-500 italic">No matches found</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchableSelect;